<template>
    <div class="row">
        
        <b-card class="col-12" no-body >
            <div class="row">
                <div class="col-12 mb-3">
                    <b-button variant="primary" @click="create" v-if="roles.includes('C')">{{ $t("GERAL.NOVO") }}</b-button>
                </div>              
                
                <div class="col-12">
                    <b-table id="table" head-variant="dark" hover :items="table.items" :fields="table.fields">
                        <template #cell(actions)="data">
                            <div class="d-flex">
                                <b-button variant="flat-primary" @click="open(data.item)" v-if="roles.includes('R')">
                                    <i class="fas fa-edit"></i>
                                </b-button>                            
                            </div>
                        </template>
                    </b-table>
                    <b-pagination
                        v-model="table.currentPage"
                        :total-rows="table.dataLength"
                        :per-page="table.perPage"
                        @change="updatePagination"
                        align="center"
                    ></b-pagination>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import helpers from "../../common/utils/helpers";
import PlanejamentoService from "@/common/services/planejamento/planejamento.service";
export default {
    data: () => ({
        table: {
            fields : [
                {key: "inicio", label: "Inicio", formatter : (v) => {
                    return helpers.formatarDataBr(v)
                } },
                {key: "fim", label: "Termino" , formatter : (v) => {
                    return helpers.formatarDataBr(v)
                }},
                {key: "versao", label: "Versão" },
                {key: "actions", label: "" },
            ],
            items : [],
            perPage : 10,
            currentPage: 1,
            dataLength : 0,
        },
        filter: ""
    }),
    methods : {
        open: function(item) {
            this.$router.push({ name: "planejamento-estrategico-formulario", params: { id : item.id } });
        },
        create: function() {
            this.$router.push({ name: "planejamento-estrategico-formulario" });
        },
        onSearch: function(e) {
            e.preventDefault();
            this.table.currentPage = 1
            this.fetch(this.filter);
        },
        updatePagination : function(page){
            this.fetch(this.filter, page - 1);
        },
        fetch: function(page = 0){
            this.$store.dispatch(START_LOADING);
            
            PlanejamentoService.fetch(this.table.perPage , page).then(response => {
                this.table.items = response.data.data.itens;
                this.table.dataLength = response.data.data.paginacao.totalDeElementos;
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });

        }
    },
    mounted() {
        this.$store.dispatch(DEFINIR_BREADCRUMB, [
            { titulo: "Planejamento estratégico" }
        ]);

        this.fetch();
    },
    computed: {
        roles() {
            return (this.$store.state.app.user.role == 'admin' ? ['C','R','U','D'] : this.$store.state.app.user.PlanejamentoEstrategico.split(','));
        }
    }
}
</script>
<style lang="">
    
</style>